import { StarIcon } from "@phosphor-icons/react/dist/csr/Star";
import { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import { normalizeRating } from "@/reviews/utils";

type RatingRow = {
  rating: number;
};

export const RatingCol = <T extends RatingRow = RatingRow>(): ColumnDef<T> => ({
  header: "Rating",
  accessorFn: (row) =>
    String(row.rating || "")
      .trim()
      .toLowerCase(),
  accessorKey: "rating",
  sortingFn: "basic",
  cell: ({ row }) => {
    const rating = normalizeRating(row.original.rating);

    return (
      <Stack direction="row" gap={1} align="center">
        {Array.from({ length: 5 }).map((_, i) => (
          <StarIcon
            weight="fill"
            key={`star-${i}`}
            className={cn("h-4 w-4 text-warning", {
              "opacity-30": i >= rating,
            })}
          />
        ))}
      </Stack>
    );
  },
});
